import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class FirewallService {

  constructor(private http: HttpClient) { }

  createServer(payload: any) {
    return this.http.post(`${environment.apiURL}/admin/firewallserver`, payload)
  }

  getAllServerList(page: number, limit: number, sortValue: string) {
    return this.http.get(`${environment.apiURL}/admin/firewallserver?page=${page}&limit=${limit}&sortValue=${sortValue}`)
  }

  getServerDetails(id: any) {
    return this.http.get(`${environment.apiURL}/admin/firewallserver/details?firewallServerId=${id}`)
  }

  updateFirewallServer(payload: any) {
    return this.http.put(`${environment.apiURL}/admin/firewallserver`, payload)
  }
  getAllFirewallServerList() {
    return this.http.get(`${environment.apiURL}/admin/firewallserver?showAll=${true}`)
  }
}
